import PropTypes from "prop-types";
import React from "react";
import createReactClass from "create-react-class";
import animate from "./mixins/React.animate.js";
var SocialAppModal = createReactClass({
    displayName: "SocialAppModal",
    mixins: [
        animate
    ],
    propTypes: {
        visible: PropTypes.bool
    },
    UNSAFE_componentWillUpdate: function UNSAFE_componentWillUpdate(nextProps, prevState) {
        if (this.props.visible != nextProps.visible) {
            var _v = nextProps.visible;
            this.animate({
                opacity: _v ? 1 : 0,
                right: _v ? 0 : "-50px"
            }, {
                duration: 300,
                display: _v ? "block" : "none"
            });
        }
    },
    render: function render() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "social-app-modal"
        }, this.props.children);
    }
});
export default SocialAppModal;
